import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@mui/material';
import BasicDetails from './forms/basic-details/BasicDetails';
import EventSchedule from './forms/schedule/EventSchedule';
import EventDescription from '../../../../../../view/dashboard/manage/Event/manage-details/event-details/forms/description/EventDescription';
import Media from '../../../../../../view/dashboard/manage/Event/manage-details/event-details/forms/media/Media';
import RedirectToTicket from '../../../../../../components/EventDetails/RedirectToTicket';
import OnlineLocation from './forms/online-location/OnlineLocation';
import CustomLocation from './forms/location/CustomLocation';
import { onTabClick } from '../../../../../../app/store/slices/event/event';
import '../../../../../../styles/components/CreateEvent.css';

function CreateEvent() {
    const dispatch = useDispatch();
    const { eventCreationTabs, activeTab, eventData } = useSelector((state) => state.event);

    function showActiveTabContent(activeTab) {
        switch (activeTab) {
            case 1:
                return <BasicDetails />;
            case 2:
                return <EventSchedule />;
            case 3:
                return <EventDescription />;
            case 4:
                return <Media />;
            case 5:
                const isOnlineEvent = eventData?.online_event ? (
                    <OnlineLocation />
                ) : (
                    <CustomLocation />
                );
                return isOnlineEvent;
            default:
                return <RedirectToTicket />;
        }
    }

    return (
        <React.Fragment>
            <section id="event-creation-section">
                <div className="event-creation-stepper">
                    {eventCreationTabs.map((tab, index) => (
                        <Button
                            key={index}
                            fullWidth
                            variant="contained"
                            onClick={() => dispatch(onTabClick(index))}
                            disabled={tab.status === 'inactive'}
                            sx={{ ...stepperBlockStyles, ...setStepperBlockStyles(tab.status) }}
                        >
                            {tab.name}
                        </Button>
                    ))}
                </div>
                <div className="event-creation-tabs-content">{showActiveTabContent(activeTab)}</div>
            </section>
        </React.Fragment>
    );
}

export default CreateEvent;

const stepperBlockStyles = {
    '&.Mui-disabled': {
        boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
        backgroundColor: 'rgba(0, 0, 0, 0.2)',
        color: 'rgba(245, 245, 245, 0.6)'
    },
    borderRadius: '0.5rem',
    textTransform: 'capitalize',
    fontFamily: 'Nunito, sans-serif',
    fontSize: '1rem',
    padding: '0.5rem 1rem'
};

function setStepperBlockStyles(status) {
    return {
        border: status === 'active' ? '1px solid #26c1e8' : '1px solid transparent',
        backgroundColor:
            status === 'active' ? '#3a414d' : status === 'completed' ? '#3a414d' : '#161e2d',
        color: status === 'active' ? '#26c1e8' : '#f5f5f5'
    };
}
